import React from "react";
import ButtonQuizLibrary from "../buttons/ButtonQuizLibrary";
import ButtonQuizCreate from "../buttons/ButtonQuizCreate";

const TextNotYourQuiz = () => {

  return (
    <div style={{
      paddingBottom: "350px",
      marginTop: "40px",
      width: "100%",
      textAlign: "center",
      fontSize: "1.2rem"
    }}>

      <div style={{ fontSize: "3rem", fontWeight: "600" }}>Sorry!</div>

      <div style={{ marginTop: "20px" }}>
        Это - ЛИЧНЫЙ квиз, принадлежащий другому пользователю.<br />
        Вы не можете его открыть.</div>
      <div style={{ marginTop: "20px" }}>
        Ищите доступные квизы в БИБЛИОТЕКЕ КВИЗОВ<br />
        или создайте свой.
      </div>

      <div
        style={{
          textAlign: "center",
          marginTop: "30px"
        }}
      >
        <ButtonQuizLibrary />
      </div>

      <div
        style={{
          textAlign: "center",
          marginTop: "20px"
        }}
      >
        <ButtonQuizCreate />
      </div>
    </div>
  )
}

export default TextNotYourQuiz